import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'
import api from 'services/api'
import { useAuth } from 'contexts/auth'

import { InsightsScope, insightsScopeFor, resolveInsightsRoute } from './insights-route'

export type { InsightsScope, InsightsRoute } from './insights-route'
export { insightsScopeFor, resolveInsightsRoute, resolveInsightsScope } from './insights-route'

interface IContractWorkspaceResponse {
  data?: { workspace?: { id: string; buyerId: string } }
}

export function useInsightsScope(): InsightsScope | null {
  const { pathname } = useLocation()
  const { user } = useAuth()
  const isSeller = Boolean(user?.isSeller)
  const ownOrganizationId = user?.organization?.id
  const route = resolveInsightsRoute(pathname)
  const workspaceId = route?.kind === 'contrato' ? route.workspaceId : undefined

  // Mesma chave e mesma chamada da tela de atividades do contrato: com ela
  // aberta, o cliente já está em cache e o botão não custa pedido nenhum.
  // Só para seller: o RH já sabe quem é o cliente (ele mesmo), ver
  // `insightsScopeFor`.
  const { data: buyerId } = useQuery({
    queryKey: ['activities', workspaceId],
    queryFn: () =>
      api.get<IContractWorkspaceResponse>(`/v2/workspaces/${workspaceId}/templates`),
    select: (response) => response?.data?.data?.workspace?.buyerId,
    enabled: Boolean(workspaceId) && isSeller,
  })

  // Sem saber o cliente ainda, não há botão: abrir sem escopo mostraria os
  // contratos de todos os clientes.
  return insightsScopeFor(route, { buyerId, isSeller, ownOrganizationId })
}
